import { render } from 'preact';
import '@fontsource/lilita-one';
import '@fontsource/nunito/400.css';
import '@fontsource/nunito/700.css';
import '@fontsource/nunito/800.css';
import './styles/base.css';
import './styles/hud.css';
import './styles/ui.css';
import './styles/ui-lobby.css';
import './styles/ui-screens.css';
import { App } from './app/App';
import { initNativeShell } from './app/native';
import { registerServiceWorker } from './pwa';

registerServiceWorker();
render(<App />, document.getElementById('app')!);
void initNativeShell();
